@let propertyPortfolioItem = propertyPortfolioItem$ | async;
@let smartSearchItem = smartSearchItem$ | async;

<div class="container mx-a relative z-index-5">
  <button
    [style.visibility]="backButtonHidden ? 'hidden' : 'visible'"
    pButton
    class="p-button p-button-primary p-button-outlined small icon-only back-button relative z-index-3"
    [routerLink]="['/', paths.PLATFORM, paths.platform.PROPERTIES]">
    <shared-icon icon="triangle-left" height="1rem" width="1rem" class="fill-dark" />
  </button>
  @if (propertyPortfolioItem) {
    <div class="items-wrapper touch-pan-y">
      <cp-portfolio-card
        (showAllCardsEmit)="showAllCards($event)"
        [portfolioItem]="propertyPortfolioItem"
        [isVisible]="true" />
    </div>
  }
  @if (smartSearchItem) {
    <div class="items-wrapper flex align-items-center">
      <cp-smart-search-card class="w-100" [smartSearch]="smartSearchItem" />
    </div>
  }
</div>
